import {
    SpacingToken,
    UiStack,
    UiText,
} from '@experiences/ui-common';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import { FontVariantToken } from '@uipath/apollo-core';
import {
    ApIcon,
    ApIconButton,
} from '@uipath/portal-shell-react';
import React from 'react';

interface PolicyDefinitionCardProps {
    title: string;
    description: string;
    onEdit: () => void;
    editDataCy?: string;
    cardDataCy?: string;
    showEditButton?: boolean;
    children: React.ReactNode;
}

export const PolicyDefinitionCard: React.FC<PolicyDefinitionCardProps> = ({
    title,
    description,
    onEdit,
    editDataCy,
    cardDataCy,
    showEditButton = true,
    children,
}) => (
    <UiStack
        direction="column"
        gap={SpacingToken.XS}
        p={SpacingToken.L}
        style={{
            flex: '1 1 0',
            minWidth: 0,
            border: '1px solid var(--color-border-de-emp)',
            borderRadius: '8px',
        }}
        data-cy={cardDataCy}
    >
        <UiStack
            direction="row"
            justify="between"
            align="center"
        >
            <UiStack
                direction="row"
                align="center"
                gap={SpacingToken.XS}
            >
                <UiText variant={FontVariantToken.fontSizeH4Bold}>
                    {title}
                </UiText>
                {!showEditButton && (
                    <ApIcon
                        name="lock"
                        size="16px"
                        color="var(--color-foreground-de-emp)"
                        data-cy={`${cardDataCy}-lock-icon`}
                    />
                )}
            </UiStack>
            <ApIconButton
                onClick={onEdit}
                data-cy={editDataCy}
                style={{
                    visibility: showEditButton ? 'visible' : 'hidden',
                    color: 'var(--color-foreground-brand)',
                }}
            >
                <EditOutlinedIcon />
            </ApIconButton>
        </UiStack>
        <UiStack
            direction="column"
            gap={SpacingToken.L}
            mt={SpacingToken.XS}
        >
            <UiText
                variant={FontVariantToken.fontSizeS}
                style={{ color: 'var(--color-foreground-de-emp)' }}
            >
                {description}
            </UiText>
            {children}
        </UiStack>
    </UiStack>
);

